import { View, Text, TextInput, StyleSheet, Platform } from "react-native";
import SimplePress from "./SimplePress";
import { useState, createElement } from "react";
import DateTimePicker from "@react-native-community/datetimepicker";
import { dateValue } from "../context/helper";

//import Ionicons from "react-native-vector-icons/Ionicons";

const InputField = ({
  label,
  icon,
  inputType,
  inputMode,
  autoCapitalize,
  keyboardType,
  multiline,
  fieldButtonLabel,
  fieldButtonFunction,
  value,
  onChangeText,
  canClear,
  style,
  editable,
  disabled,
}) => {
  const textstyle =
    style ? (Array.isArray(style) ? Object.assign({}, ...style) : style):undefined;

  let dateinit = new Date();
  if (inputType == "datepicker") {
    if (value) {
      dateinit = new Date(value);
    }
  }

  const [date, setDate] = useState(dateinit);
  const [datestr, setDateStr] = useState(
    value ? dateValue(dateinit, true) : label
  );
  const [showPicker, setShowPicker] = useState(false);

  function invertColor(hex,doinvert) {
    if (!hex || !doinvert)
      return hex;

    if (hex.indexOf('#') === 0) {
        hex = hex.slice(1);
    }
    // convert 3-digit hex to 6-digits.
    if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    if (hex.length !== 6) {
        throw new Error('Invalid HEX color.');
    }
    // invert color components
    var r = (255 - parseInt(hex.slice(0, 2), 16)).toString(16),
        g = (255 - parseInt(hex.slice(2, 4), 16)).toString(16),
        b = (255 - parseInt(hex.slice(4, 6), 16)).toString(16);
    // pad each with zeros and return
    return '#' + padZero(r) + padZero(g) + padZero(b);
}

function padZero(str, len) {
    len = len || 2;
    var zeros = new Array(len).join('0');
    return (zeros + str).slice(-len);
}
  const MyWebDatePicker = ({ value, onChange }) => {
    return createElement("input", {
      type: "date",
      value: value.toISOString().split("T")[0],
      onChange: (event) => {
        onChange(new Date(event.target.value));
      },
      style: {
        height: 30,
        padding: 5,
        border: "0px solid #677788",
        borderRadius: 5,
        width: "100%",
        background: textstyle?invertColor(textstyle.backgroundColor,textstyle.doinvert):undefined,
        fontFamily: textstyle?textstyle.fontFamily:undefined,
        fontSize: textstyle?textstyle.fontSize:undefined,
        color: textstyle?invertColor(textstyle.color,textstyle?textstyle.doinvert:false):undefined,
        filter: textstyle?(textstyle.doinvert?"invert(1)":undefined):undefined
      },
    });
  };

  const toggleDatepicker = () => {
    setShowPicker(!showPicker);
  };

  const showDatePicker = () => {
    setShowPicker(true);
  };

  const onDateChange = ({ type }, selectedDate) => {
    if (type == "set") {
      setShowPicker(false);
      const currentDate = selectedDate;
      setDate(currentDate);
      setDateStr(dateValue(currentDate, true));
      if (onChangeText) onChangeText(currentDate);
    } else {
      toggleDatepicker();
    }
  };

  const isWebPicker = () => {
    let isWeb = inputType === "datepicker" && Platform.OS === "web";
    return isWeb;
  };
  const placeholderColor = (dis) => {
    let res = undefined;
    if (textstyle) 
        res = dis?textstyle.placeholderDisabledColor:textstyle.placeholderColor;
    
    if (!res) 
      res = dis?"#aaa":"#888";
    return res;
  }
  return (
    <View style={[styles.inputContainer,style]}>
      {!isWebPicker() && icon}
      {inputType == "datepicker" ? (
        <>
          {isWebPicker() ? (
            <MyWebDatePicker
              value={date}
              onChange={(newdate) => {
                setDate(newdate);
                setDateStr(dateValue(newdate, true));
                if (onChangeText) onChangeText(newdate);
              }}
            />
          ) : (
            <>
              <SimplePress style={{ flex: 1 }} onPress={() => showDatePicker()}>
                <Text style={styles.dateText}>{datestr}</Text>
              </SimplePress>
              {datestr !== label && canClear && (
                <SimplePress
                  onPress={() => {
                    setDate(null);
                    setDateStr(label);
                  }}
                >
                  <Text style={styles.forgotText}>Clear</Text>
                </SimplePress>
              )}
              {showPicker && (
                <DateTimePicker
                  mode="date"
                  display="spinner"
                  value={date}
                  onChange={onDateChange}
                />
              )}
            </>
          )}
        </>
      ) : (
        <TextInput
          multiline={multiline}
          inputMode={inputMode}
          autoCapitalize={autoCapitalize}
          placeholder={label}
          placeholderTextColor={placeholderColor(disabled)}
          keyboardType={keyboardType}
          style={[
            styles.inputField,
            textstyle && { fontFamily: textstyle.fontFamily, fontSize: textstyle.fontSize, height: textstyle.height, color: textstyle.color },
          ]}
          secureTextEntry={inputType == "password" ? true : false}
          value={value}
          onChangeText={onChangeText}
          editable={!disabled && editable}
        />
      )}
      {fieldButtonLabel && (
        <SimplePress onPress={fieldButtonFunction}>
          <Text style={styles.forgotText}>{fieldButtonLabel}</Text>
        </SimplePress>
      )}
    </View>
  );
};

export default InputField;

const styles = StyleSheet.create({
  inputContainer: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderColor: "#ccc",
    paddingBottom: 8,
    alignItems: "center",
  },
  inputField: {
    flex: 1,
    marginLeft: 5,
    paddingVertical: 0,
  },
  forgotText: {
    color: "#AD40AF",
    fontWeight: "700",
  },
  dateText: {
    color: "#666",
    marginLeft: 5,
  },
});
